'use strict';

var $ = require('jquery');

function init() {

	if ($('.categories').length === 0)
		return;

	var categoryChangeFunction = function(url, data, $form) {
		$.ajax({
			type: 'POST',
			url: url,
			data: data,
			success: function(response) {
				var $response = $(response);
				// Update location bar to match what the page is rendering
				if (history !== undefined) {
					history.pushState(null, null, url);
				}

				// Replace main content are of page with new content
				var formId = $form.attr('id');
				var $newForm = $response.find('#' + formId);
				$form.replaceWith($newForm);
			}
		});

	};

	$('body').on('click', '.categories .category a', function(event) {
		event.preventDefault();

		var $form = $(this).closest('form');
		var target = $(this).attr('name');
		var url = $form.attr('action');
		var data = target ? 'category=' + target : '';
		if (target) {
			//$(this).trigger('analyticsEvent', target); // No longer does anything
			url += '?category=' + target;
		}
		categoryChangeFunction(url, data, $form);
	});

	$('body').on('change', '.categories--mobile .categories--mobile__select', function(event) {
		event.preventDefault();

		var $form = $(this).closest('form');
		var target = $(this).val();
		var url = $form.attr('action');
		var data = target ? 'category=' + target : '';
		if (target) {
			url += '?category=' + target;
		}
		categoryChangeFunction(url, data, $form);
	});
}

module.exports = {
	init : init
};
